import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import withRoot from './modules/withRoot';
import ScrollToTop from './modules/components/ScrollToTop';
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import Terms from './pages/dashboard/Terms';
import Privacy from './pages/dashboard/Privacy';
import Dashboard from './pages/Dashboard';
import Verification from './pages/Verification';
import SignOut from './pages/SignOut';
import Subscriptions from './pages/dashboard/Subscriptions';
import Video from './modules/components/Video';
import Donate from './pages/dashboard/Donate';
import ForgotPasswordVerification from './pages/ForgotPasswordVerification';
import Upgrade from './pages/dashboard/Upgrade';
import UpdateProfile from './pages/dashboard/UpdateProfile';
import ChangePassword from './pages/dashboard/ChangePassword';
import ThankYou from './pages/dashboard/ThankYou';

Amplify.configure({
  API: {
    graphql_headers: async () => {
      const currentSession = await Auth.currentSession();
      return { Authorization: currentSession.getIdToken().getJwtToken() };
    }
  },
  ...awsconfig,
});

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route index element={<Home />} />
        <Route path='/sign-in' element={<SignIn />} />
        <Route path='/sign-up' element={<SignUp />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/verification' element={<Verification />} />
        <Route path='/sign-out' element={<SignOut />} />
        <Route path='/forgot-password-verification' element={<ForgotPasswordVerification />} />
        <Route path='/dashboard' element={<Dashboard />}>
          <Route index element={<Subscriptions />} />
          <Route path='terms' element={<Terms inOutlet />} />
          <Route path='privacy' element={<Privacy inOutlet />} />
          <Route path='tutorial' element={<Video />} />
          <Route path='donate' element={<Donate />} />
          <Route path='upgrade' element={<Upgrade />} />
          <Route path='update-profile' element={<UpdateProfile />} /> 
          <Route path='change-password' element={<ChangePassword />} />
          <Route path='thank-you' element={<ThankYou />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default withRoot(App);
